import util from '../util'

let controller = 'ContaChavePix'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'getall', 'delete']), {
    ConsultaChaveOnline: function (dto) {
        return util.Axios.GetAll(controller + '/ConsultaChaveOnline', dto, true)
  },
    ConsultaRastreada: function (dto) {
    return util.Axios.GetAll(controller + '/ConsultaRastreada', dto, true)
    }
})

